import { Component, Input, OnInit } from '@angular/core';
import { MetaDataService, TradeType } from '../services/meta-data.service';
import { ExternalRedirectPopupType, PopupService, SpecialPopupType } from '../services/popup.service';
import { TranslateModule } from '@ngx-translate/core';
import { TradeTypes } from '../services/globals.service';

@Component({
  selector: 'HomeServices-clickout-link',
  templateUrl: './clickout-link.component.html',
  styleUrls: ['./clickout-link.component.css'],
})
export class ClickoutLinkComponent implements OnInit {

  // globals
  public tradeTypes = TradeTypes;
  public specialPopupTypes = SpecialPopupType;

  // params
  @Input() iconSrc: string = ``;
  @Input() redirectURL: string = ``;
  @Input() tradeName: string = ``;
  @Input() externalRedirectPopupType: ExternalRedirectPopupType = ExternalRedirectPopupType.RedirectGeneric; 
  @Input() pageContentParams: any = {};
  @Input() showInfo: boolean = false;
  @Input() tradeTypeID: number = 0;

  constructor(
    private metadataService: MetaDataService, 
    private popupService: PopupService
  ) { }

  ngOnInit() {
  }

  public triggerExternalRedirect() {
    this.metadataService.pushAAStartExternalTrade(this.tradeName);
    this.popupService.openRedirectPopup(this.externalRedirectPopupType, this.redirectURL);
  }

  public showTradeTypeInformationPopup() {
    this.popupService.openSpecialPopup(this.specialPopupTypes.TradeTypeInformation, '', this.tradeTypeID);
  }

}
